import Axios from "axios";
var PurchaseRefundForUpperSupService = (function () {
    function PurchaseRefundForUpperSupService() {
    }
    PurchaseRefundForUpperSupService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/upperrefund/list", { params: params });
    };
    PurchaseRefundForUpperSupService.prototype.getListGoods = function (params) {
        return Axios.post("supplierclientapi/upperrefund/list_goods", params);
    };
    PurchaseRefundForUpperSupService.prototype.getGoodsList = function (params) {
        return Axios.post("supplierclientapi/upperrefund/get_goods_list", params);
    };
    PurchaseRefundForUpperSupService.prototype.addOrder = function (params) {
        return Axios.post("supplierclientapi/upperrefund/create", params);
    };
    PurchaseRefundForUpperSupService.prototype.updOrder = function (params) {
        return Axios.post("supplierclientapi/upperrefund/update", params);
    };
    PurchaseRefundForUpperSupService.prototype.getDetail = function (params) {
        return Axios.post("supplierclientapi/upperrefund/detail", params);
    };
    PurchaseRefundForUpperSupService.prototype.audit = function (params) {
        return Axios.get("supplierclientapi/upperrefund/audit", { params: params });
    };
    PurchaseRefundForUpperSupService.prototype.discard = function (params) {
        return Axios.post("supplierclientapi/upperrefund/cancel", params);
    };
    PurchaseRefundForUpperSupService.prototype.sendEmail = function (params) {
        return Axios.post("supplierclientapi/upperrefund/send_email", params);
    };
    PurchaseRefundForUpperSupService.prototype.getSupplierupperOptions = function (params) {
        return Axios.get("supplierclientapi/supplierupper/get_options", { params: params });
    };
    PurchaseRefundForUpperSupService.prototype.getAccountOptions = function (params) {
        return Axios.get("supplierclientapi/account/get_options", { params: params });
    };
    PurchaseRefundForUpperSupService.prototype.getSupplierorganOptions = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    PurchaseRefundForUpperSupService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    PurchaseRefundForUpperSupService.prototype.getUpperWareHouseOrderCodeOptions = function (params) {
        return Axios.post("supplierclientapi/upperrefund/get_warehouse_order_options", params);
    };
    PurchaseRefundForUpperSupService.prototype.getGoodByUpperWarehouseOrderCode = function (params) {
        return Axios.post("supplierclientapi/upperwarehouse/detail_goods_list", params);
    };
    PurchaseRefundForUpperSupService.createInstance = function () {
        PurchaseRefundForUpperSupService.getInstance();
    };
    PurchaseRefundForUpperSupService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return PurchaseRefundForUpperSupService;
}());
export default PurchaseRefundForUpperSupService;
